const CONFIGURED_API = process.env.REACT_APP_API_BASE_URL;

export const DJANGO_API =
  CONFIGURED_API && CONFIGURED_API.trim()
    ? CONFIGURED_API.trim().replace(/\/+$/, "")
    : process.env.NODE_ENV === "production"
    ? "https://staging.kaakazini.com/api"
    : "http://localhost:8000/api";

export const productEndpoint = (id) =>
  `${DJANGO_API}/shop/products/${encodeURIComponent(id)}/`;

export const CHECKOUT_ENDPOINT = `${DJANGO_API}/shop/checkout/`;
export const orderStatusEndpoint = (shopifyOrderId) =>
  `${DJANGO_API}/shop/order/${encodeURIComponent(shopifyOrderId)}/status/`;

export const SHIPPING_FEE = 200;

export const KAAKAZINI_LOGO = "/kakaazini.png";

export const T = {
  yellow: "#fff000",
  yellowDark: "#e3d600",
  black: "#000000",
  white: "#ffffff",
  ink: "#000000",
  inkSoft: "rgba(0,0,0,0.66)",
  muted: "rgba(0,0,0,0.45)",
  faint: "rgba(0,0,0,0.26)",
  border: "rgba(0,0,0,0.13)",
  borderSoft: "rgba(0,0,0,0.08)",
  surface: "#f6f6f2",
  error: "#b02a37",
};

export const F = {
  display: "'Raleway', sans-serif",
  body: "'Raleway', sans-serif",
};

export const formatKsh = (n) => `KSh ${Number(n || 0).toLocaleString()}`;